import { useToastContainer } from 'modules/layout/toastContainer';
import { useEffect } from 'react';
import {
  NavigationAndActionClose,
  NavigationAndActionFailSmall,
  NavigationAndActionInfoSmall,
} from '../icons';
import { theme } from '../theme';
import { ToggleButtonType } from '../toggleButton';
import {
  StyledCloseButton,
  StyledIconContainer,
  StyledText,
  StyledTextContainer,
  StyledTitle,
  StyledToastContainer,
} from './styled';
import { ToastType } from './ToastType';

export interface ToastProps {
  id?: string;
  text: string;
  title: string;
  type?: ToastType;
  timeout?: number;
}

export const Toast: React.FC<ToastProps> = ({
  id,
  text,
  title,
  type = ToastType.Info,
  timeout = 5000,
}) => {
  const { removeToast } = useToastContainer();

  useEffect(() => {
    timeout &&
      setTimeout(() => {
        id && removeToast(id);
      }, timeout);
  }, [id, removeToast, timeout]);

  return (
    <StyledToastContainer type={type}>
      <StyledIconContainer>
        {type === ToastType.Info && <NavigationAndActionInfoSmall />}
        {type === ToastType.Urgent && <NavigationAndActionFailSmall />}
      </StyledIconContainer>
      <StyledTextContainer>
        <StyledTitle>{title}</StyledTitle>
        <StyledText>{text}</StyledText>
      </StyledTextContainer>
      <StyledCloseButton
        onClick={() => id && removeToast(id)}
        type={ToggleButtonType.Icon}
        icon={<NavigationAndActionClose />}
        color={theme.colors.primaryW}
      />
    </StyledToastContainer>
  );
};
